import React from 'react'
import { FRAMEWORK_TYPE_FILTER_VALUE } from 'src/pages/Frameworks/frameworks.helpers'
import { FilterName, FilterParam } from '../FilterBar.types'
import { FilterDropdown } from './FilterDropdown'

const filterValues = [
  { value: FRAMEWORK_TYPE_FILTER_VALUE.CUSTOM, label: 'Custom' },
  { value: FRAMEWORK_TYPE_FILTER_VALUE.CATALOG, label: 'Catalog' },
]

export const FrameworkTypeFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => (
    <FilterDropdown
      filterParam={FilterParam.FRAMEWORK_TYPE}
      filterName={FilterName.FRAMEWORK_TYPE}
      filterValues={filterValues}
      isNested={isNested}
    />
  ),
)
